/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Text_To_Audio_RedoInputs */

const en_dialog_text_to_audio_redo = /** @type {(inputs: Dialog_Text_To_Audio_RedoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redo`)
};

const es_dialog_text_to_audio_redo = /** @type {(inputs: Dialog_Text_To_Audio_RedoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rehacer`)
};

/**
* | output |
* | --- |
* | "Redo" |
*
* @param {Dialog_Text_To_Audio_RedoInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio_redo = /** @type {((inputs?: Dialog_Text_To_Audio_RedoInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_Audio_RedoInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio_redo(inputs)
	return en_dialog_text_to_audio_redo(inputs)
});